import React from 'react'
import { useNavigate } from 'react-router-dom'

const ArrowButton = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Mobile Button */}
      <div className="block sm:hidden mt-2">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center justify-center px-3 py-2 shadow-[0px_0px_2.86px_0px_#00000040] rounded-[10px] h-10 mr-3 min-w-[40px]"
        >
          <img src="/assets/clarity_arrow-line.svg" alt="Arrow Left" className="w-5 h-5" />
        </button>
      </div>

      {/* Desktop Button */}
      <div className="hidden sm:block mt-2">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center justify-center px-4 py-3 shadow-[0px_0px_2.86px_0px_#00000040] rounded-[10px] h-12 mr-4"
        >
          <img src="/assets/clarity_arrow-line.svg" alt="Arrow Left" />
        </button>
      </div>
    </>
  )
}

export default ArrowButton;
